import { client, getUrl } from "../../../../../utils";

export const getConfigsRequest = (filterParams) => client.get(getUrl("configs", filterParams));

export const createConfigsRequest = (data) => client.post("configs", data);

export const createQuickStartRequest = (data) => client.post("initial-scrape-task/quick-start", data);

export const checkStatusScrapeTaskRequest = (id) => client.get(`scrape-task/${id}/trace`).then(({ is_finished }) => ({ id, is_finished }));
